import React from 'react';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMUserResource from 'resources/SMUserResource';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMUSettingEditSecurityFragmentView extends SMUSettingEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user, 
      isCurrent : this.isCurrent(this.props),
      errorMessage: "",
    };
  }
  
  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_000183'));
    
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  formDidSubmit(e){
    e.preventDefault();    
    let formData = new FormData(e.currentTarget);
    SMUserResource.updatePassword(formData, (data, error, xhr)=>{
      if(error) {
        this.setState({errorMessage: xhr.responseJSON.message});
        return;
      } else if (xhr.status == 200) {
        this.props.delegate.showSuccessMessage();
        if(this.state.errorMessage) this.setState({errorMessage: ""});
        this.refs.form.reset();
      }
    });    
  }
  
  render() {
    let errorRow = (this.state.errorMessage) ? <p className="is-error mb10">{this.state.errorMessage}</p> : "";

    return(
      <div style={this.fragmentStyle()}>
        <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
          <SMFormFieldTitle title={I18n.t('dashboard.label_000200')} subTitle={I18n.t('dashboard.text_000042')} />
          <div className="form-box">
            <p className="mb10">
              <span className="dib w200">{I18n.t('dashboard.label_000197')}</span>
              <SMFormTextField
                type="password"
                name="current_password" 
                options={{className:'form-text w300'}}
                delegate={this}
              />
            </p>
            <p className="mb10">
              <span className="dib w200">{I18n.t('dashboard.label_000198')}</span>
              <SMFormTextField
                type="password"
                name="password" 
                options={{className:'form-text w300'}}
                delegate={this}
              />
            </p>
            <p className="mb10">
              <span className="dib w200">{I18n.t('dashboard.label_000199')}</span>
              <SMFormTextField
                type="password"
                name="password_confirmation" 
                options={{className:'form-text w300'}}
                delegate={this}
              />
            </p>
            {errorRow}
          </div>        
          <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
            <input className="button-green maincol-buttonarea__button" type="submit" value="保存" />
          </div>
        </form>
      </div>
    );
  }
}
export default SMUSettingEditSecurityFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditSecurityFragmentView.jsx